<p-tabs scrollable class="eventDash" (onChange)="onTabChange($event)" value="0">
  <p-tablist>
    <p-tab value="0">Engagements Count</p-tab>
    <p-tab value="1">Customer Acknowledgements</p-tab>
    <p-tab value="2">Customer Validation Review</p-tab>
    <p-tab value="3">MRPP POE Documents</p-tab>
    <p-tab value="4">Customer Surveys</p-tab>
    <p-tab value="5">All Engagements</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (isEngagementsCountSelected) {
        <app-mrpp-count></app-mrpp-count>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-customer-acknowledgement></app-customer-acknowledgement>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-event-review-table
        [eventSearchType]="
          EventSearchType.CustomerValidationReview
        "></app-event-review-table>
    </p-tabpanel>
    <p-tabpanel value="3">
      <app-poe-documents></app-poe-documents>
    </p-tabpanel>
    <p-tabpanel value="4">
      <app-customer-surveys></app-customer-surveys>
    </p-tabpanel>
    <p-tabpanel value="5">
      <app-all-engagements></app-all-engagements>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
